import * as React from 'react';
import RefreshIconAndText from '@components/common/RefreshIconAndText';

class ErrorBoundary extends React.Component<{ fallback?: React.ReactNode; children: React.ReactNode }, { hasError: boolean }> {
  constructor(props: { fallback?: React.ReactNode; children: React.ReactNode }) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error: Error) {
    return { hasError: true };
  }

  componentDidCatch(error: Error, info: React.ErrorInfo) {
    console.group('Information about error');
    console.log('Error:', error);
    console.log('Component Stack:', info.componentStack);
    console.groupEnd();
    //TODO: add error log here in future
  }

  render() {
    if (this.state.hasError) {
      return this.props.fallback || <RefreshIconAndText addClass="pt-[100px]" />;
    }

    return this.props.children;
  }
}

export default ErrorBoundary;